import styles from "./ChangeemailId.module.css";
import Button from "./../utilities/button/Button";
import { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";

function ChangeEmailId() {
  const [email, setEmail] = useState("");
  const [btnStatus, SetBtnStatus] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [otpVisible, SetOtpVisible] = useState(false);
  const [responseText, setResponseText] = useState("");
  const [enterOTP, setEnterOTP] = useState("");
  const [intervalTime, setIntervaltime] = useState("");

  const [otpOverlay, setOtpOverlay] = useState(false);
  const [tryAgain, SetTryAgain] = useState(false);
  const [mailUpdate, setMailUpdate] = useState(false);
  const [otpBtn, setOtpBtn] = useState(false);

  function EmailHandler(e) {
    setEmail(e.target.value);
  }

  function OtpHandler(e) {
    setEnterOTP(e.target.value);
  }

  async function submitHandler(e) {
    e.preventDefault();
    SetBtnStatus(true);
    SetOtpVisible(true);
    let num = 20;
    const intervalId = setInterval(function () {
      num = num - 1;
      if (num <= 0) {
        clearInterval(intervalId);
      }

      setIntervaltime(num);
    }, 1000);
    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/user/updateemail`,
        {
          method: "POST",
          body: JSON.stringify({ email_update: email }),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (!result.ok) {
        SetBtnStatus(false);
        SetOtpVisible(false);
        SetTryAgain(false);
      }
      const text = await result.json();
      setResponseText(text.message);
      setOtpOverlay(true);
      SetTryAgain(true);
    } catch (err) {
      console.log(err);
    }
  }
  async function VerifyOtp(e) {
    e.preventDefault();
    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/user/verifyotp`,
        {
          method: "POST",
          body: JSON.stringify({ otp: enterOTP }),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (!result.ok) {
        setMailUpdate(false);
        setOtpBtn(false);
      }
      setMailUpdate(true);
      setOtpBtn(true);
      setEnterOTP("");
    } catch (err) {
      console.log(err.message);
    }
  }

  useEffect(() => {
    setTimeout(function () {
      SetBtnStatus(false);
      SetTryAgain(false);
    }, 27000);
  }, [btnStatus]);

  function closeOverlay() {
    setOtpOverlay(false);
  }

  return (
    <>
      <div
        className={otpOverlay ? `${styles.overlay}` : `${styles.overlayClose}`}
      >
        <div className={styles.overlayBox}>
          <div className={styles.close}>
            {<IoMdCloseCircle onClick={closeOverlay}></IoMdCloseCircle>}
          </div>
          <form onSubmit={VerifyOtp}>
            <input
              className={styles.input}
              type="text"
              placeholder="OTP"
              onChange={OtpHandler}
              value={enterOTP}
            ></input>
            {mailUpdate ? (
              <p style={{ color: "green", marginBottom: "20px" }}>
                OTP Verified Successfully, New Email Updated
              </p>
            ) : (
              <p style={{ color: "green", marginBottom: "20px" }}>
                {responseText}
              </p>
            )}

            <Button disabled={otpBtn}>Verify OTP</Button>
          </form>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.box}>
          <h1 className={styles.heading}>Change Email Id</h1>
          <form className={styles.formOne} onSubmit={submitHandler}>
            <input
              className={styles.input}
              type="text"
              placeholder="Your New Email Id"
              value={email}
              onChange={EmailHandler}
            ></input>

            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <Button disabled={email.length < 0 || btnStatus}>
                {btnStatus ? "Wait..." : "Submit"}
              </Button>
              <p
                className={
                  tryAgain ? `${styles.tryAgain}` : `${styles.tryAgainNone}`
                }
              >
                Try Again After <strong>{intervalTime}</strong> Seconds
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default ChangeEmailId;
